/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHolidayVillageIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-holiday-village"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.33 20.32Q3.2 20.32 2.44 19.56Q1.68 18.8 1.68 17.68L1.68 10.97Q1.68 10.45 1.88 9.96Q2.08 9.47 2.45 9.1L6.13 5.42Q6.53 5.03 7.01 4.84Q7.5 4.65 8 4.65Q8.5 4.65 8.99 4.84Q9.47 5.03 9.88 5.42L13.55 9.1Q13.93 9.47 14.13 9.96Q14.32 10.45 14.32 10.97L14.32 17.68Q14.32 18.8 13.56 19.56Q12.8 20.32 11.68 20.32L10 20.32Q9.72 20.32 9.53 20.14Q9.32 19.95 9.32 19.68L9.32 16Q9.32 15.45 8.94 15.06Q8.55 14.68 8 14.68Q7.45 14.68 7.06 15.06Q6.67 15.45 6.67 16L6.67 19.65Q6.67 19.93 6.49 20.13Q6.3 20.32 6.03 20.32ZM15.68 19L15.68 9.3Q15.68 9.3 15.68 9.3Q15.68 9.3 15.68 9.3L12.3 5.92Q11.68 5.3 12.01 4.49Q12.35 3.67 13.22 3.67Q13.5 3.67 13.72 3.76Q13.95 3.85 14.15 4.05L17.55 7.45Q17.93 7.83 18.13 8.31Q18.32 8.8 18.32 9.32L18.32 19Q18.32 19.55 17.94 19.94Q17.55 20.32 17 20.32Q16.45 20.32 16.06 19.94Q15.68 19.55 15.68 19ZM19.68 19L19.68 7.65Q19.68 7.65 19.68 7.65Q19.68 7.65 19.68 7.65L17.95 5.92Q17.32 5.3 17.66 4.49Q18 3.67 18.88 3.67Q19.15 3.67 19.38 3.76Q19.6 3.85 19.8 4.05L21.55 5.8Q21.93 6.17 22.13 6.66Q22.32 7.15 22.32 7.67L22.32 19Q22.32 19.55 21.94 19.94Q21.55 20.32 21 20.32Q20.45 20.32 20.06 19.94Q19.68 19.55 19.68 19ZM8 13.32Q8 13.32 8.28 13.32Q8.55 13.32 8.94 12.94Q9.32 12.55 9.32 12Q9.32 11.45 8.94 11.06Q8.55 10.68 8 10.68Q7.45 10.68 7.06 11.06Q6.67 11.45 6.67 12Q6.67 12.55 7.06 12.94Q7.45 13.32 8 13.32Z" fill={color} />
    </svg>
  );
}
